import Notification from '@serko/zui/es/Notification';
import NotificationContentText from '@serko/zui/es/NotificationContentText';
import React, { FunctionComponent } from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import messages from '../../intl/messages';
import Typography from '@material-ui/core/Typography';

interface OwnProps {
  isSaviSelectIntl: boolean;
}

interface InfoProps extends OwnProps, InjectedIntlProps {}

const InfoBase: FunctionComponent<InfoProps> = ({
  intl: { formatMessage },
  isSaviSelectIntl,
}) => (
  <Notification type="Info">
    <NotificationContentText>
      <Typography variant="subheading">
        {formatMessage(messages.notification.trip.info)}
      </Typography>
      {isSaviSelectIntl && (
        <Typography variant="body1">
          {formatMessage(messages.notification.trip.disclaimer)}
        </Typography>
      )}
    </NotificationContentText>
  </Notification>
);

export const Info = injectIntl(InfoBase);

Info.displayName = 'Info';
